/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
import '../../roster/business_hours';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "AutomatedBusinessInfo": {
                "fields": {
                  "businessName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "googlePlaceType": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "googlePlaceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": ".squareup.common.location.Phone",
                    "id": 5,
                    "rule": "optional"
                  },
                  "coordinates": {
                    "type": ".squareup.common.location.Coordinates",
                    "id": 6,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "businessHours": {
                    "type": ".squareup.roster.business_hours.BusinessHours",
                    "id": 8,
                    "rule": "optional"
                  },
                  "specialHours": {
                    "type": ".squareup.roster.business_hours.SpecialBusinessHours",
                    "id": 9,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.AutomatedBusinessInfo) {
  $root.addJSON(jsonData);
}

/**
 * Represents business information collected from Google Places API and other sources
 *
 * SOURCE AutomatedBusinessInfo @ squareup/onboarding/business/automated_business_info.proto at 13:1
 */
export const AutomatedBusinessInfo = $root.lookupType('squareup.onboarding.business.AutomatedBusinessInfo');
fixType(AutomatedBusinessInfo);
Builder.createAndAttachToType(AutomatedBusinessInfo);